export default "mdc-dialog-surface {\n  min-width: 480px !important;\n  overflow: hidden;\n}\n\n.project-info {\n  padding: 4px;\n  padding-left: 24px;\n}"